export const PROCESSING_EVENT_RESOURCE_TYPE = {
  DOCUMENT: 'DOCUMENT',
  SEARCH_QUERY: 'SEARCH_QUERY',
};

export const PROCESSING_EVENT_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  ERROR: 'ERROR',
};

export const PROCESSING_EVENT_STATUS_LABEL = {
  [PROCESSING_EVENT_STATUS.NOT_STARTED]: 'Not started',
  [PROCESSING_EVENT_STATUS.IN_PROGRESS]: 'In progress',
  [PROCESSING_EVENT_STATUS.FINISHED]: 'Complete',
  [PROCESSING_EVENT_STATUS.ERROR]: 'Error',
};

export function processingEventStatusToLabel(status) {
  return PROCESSING_EVENT_STATUS_LABEL[status];
}

export const PROCESSING_EVENT_TYPE = {
  DOCUMENT_OCR: 'DOCUMENT_OCR',
  DOCUMENT_PARSE: 'DOCUMENT_PARSE',
  DOCUMENT_CLASSIFY: 'DOCUMENT_CLASSIFY',
  DOCUMENT_ANALYSE_FRAUD_SIGNALS: 'DOCUMENT_ANALYSE_FRAUD_SIGNALS',
  DOCUMENT_EVALUATE_DOCUMENT_RULES: 'DOCUMENT_EVALUATE_DOCUMENT_RULES',
  DOCUMENT_TRUST_SCORE: 'DOCUMENT_TRUST_SCORE',
  DOCUMENT_CHECKS: 'DOCUMENT_CHECKS',
  DOCUMENT_PARSE_KEY_DETAILS: 'DOCUMENT_PARSE_KEY_DETAILS',
  DOCUMENT_VISUAL_CHECKS: 'DOCUMENT_VISUAL_CHECKS',
  DOCUMENT_VERIFICATIONS: 'DOCUMENT_VERIFICATIONS',
  DOCUMENT_DETERMINE_RISK_LEVEL: 'DOCUMENT_DETERMINE_RISK_LEVEL',
  SEARCH_QUERY_DB: 'SEARCH_QUERY_DB',
  SEARCH_SUMMARIZE_RESULTS: 'SEARCH_SUMMARIZE_RESULTS',
};

export const PROCESSING_EVENT_TYPE_LABEL = {
  [PROCESSING_EVENT_TYPE.DOCUMENT_OCR]: 'Run OCR',
  [PROCESSING_EVENT_TYPE.DOCUMENT_PARSE]: 'Parse document',
  [PROCESSING_EVENT_TYPE.DOCUMENT_CLASSIFY]: 'Classify document',
  [PROCESSING_EVENT_TYPE.DOCUMENT_ANALYSE_FRAUD_SIGNALS]:
    'Analyse fraud signals',
  [PROCESSING_EVENT_TYPE.DOCUMENT_EVALUATE_DOCUMENT_RULES]:
    'Evaluate document rules',
  [PROCESSING_EVENT_TYPE.DOCUMENT_TRUST_SCORE]: 'Calculate scores',
  [PROCESSING_EVENT_TYPE.DOCUMENT_CHECKS]: 'Run document checks',
  [PROCESSING_EVENT_TYPE.DOCUMENT_PARSE_KEY_DETAILS]: 'Parse key details',
  [PROCESSING_EVENT_TYPE.DOCUMENT_VISUAL_CHECKS]: 'Perform visual checks',
  [PROCESSING_EVENT_TYPE.DOCUMENT_VERIFICATIONS]: 'Run verifications',
  [PROCESSING_EVENT_TYPE.DOCUMENT_DETERMINE_RISK_LEVEL]: 'Determine risk level',
  [PROCESSING_EVENT_TYPE.SEARCH_QUERY_DB]: "Query your workspace's data",
  [PROCESSING_EVENT_TYPE.SEARCH_SUMMARIZE_RESULTS]: 'Summarize results',
};

export function processingEventTypeToLabel(type) {
  return PROCESSING_EVENT_TYPE_LABEL[type];
}
